import { render, staticRenderFns } from "./NewTreatment.vue?vue&type=template&id=484fa096&scoped=true"
import script from "./NewTreatment.vue?vue&type=script&lang=js"
export * from "./NewTreatment.vue?vue&type=script&lang=js"
import style0 from "./NewTreatment.vue?vue&type=style&index=0&id=484fa096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fa096",
  null
  
)

export default component.exports